export const cardExpirationDateMask = [/\d/, /\d/, '/', /\d/, /\d/];
